// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3C-K2","infoBtn":"quickbooks_infoBtn__2uPPa","formBox":"quickbooks_formBox__2Q4kI","formFooter":"quickbooks_formFooter__ohFe-"};